import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[scrollTracker]',
    standalone: false
})
export class ScrollTrackerDirective {
  @Output() scrollingFinished = new EventEmitter<void>();

  emitted = false;

  @HostListener('window:scroll', [])
  onScroll(): void {
    const isEndOfPage = window.innerHeight + window.scrollY >= document.body.offsetHeight;
    if (isEndOfPage && !this.emitted) {
      this.emitted = true;
      this.scrollingFinished.emit();
    } else if (!isEndOfPage) {
      this.emitted = false;
    }
  }
}
